const state = {
    data: {},
    edited: {},
    editInfo: {
        categoryId: null,
        kelasPaket: "",
        detailId: null,
        kelasId: null,
        category: null,
    },
    onEdit: {},
    raw: null,
};

const mutations = {
    packages_init_raw(state, payload) {
        state.raw = payload;
    },

    packages_init(state, payload) {
        state.data = payload;
    },

    packages_edited(state, payload) {
        state.edited = payload;
    },

    package_onedit(state, payload) {
        state.onEdit = payload;
    },

    package_info_update(state, payload) {
        state.editInfo.categoryId = payload.categoryId;
        state.editInfo.kelasPaket = payload.kelasPaket;
        state.editInfo.detailId = payload.detailId;
        state.editInfo.kelasId = payload.idKelas;
        state.editInfo.category = payload.category;
    },

    landing_packages_clear(state) {
        state.data = {};
        state.edited = {};
        state.editInfo = {
            categoryId: null,
            kelasPaket: "",
            detailId: null,
            category: null,
        };
        state.onEdit = {};
        state.raw = null;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/global/stores/landing_packages.js